import { http, type HttpClient } from './core/http-client';
import type { AccountProfile, ClaimStarted, MyBusiness, NewBusiness, StartClaim } from './models';

// The signed-in user's account, before a business is selected (/business/me).
export class AccountService {
  constructor(private readonly http: HttpClient) {}

  profile = () => this.http.get<AccountProfile>('/business/me/profile');

  updateProfile = (b: { displayName?: string; countryCode?: string | null }) =>
    this.http.patch<AccountProfile>('/business/me/profile', b);

  businesses = () => this.http.get<MyBusiness[]>('/business/me/businesses');

  createBusiness = (b: NewBusiness) => this.http.post<MyBusiness>('/business/me/businesses', b);

  startClaim = (b: StartClaim) => this.http.post<ClaimStarted>('/business/me/claims', b);

  verifyClaim = (claimId: string, token?: string) =>
    this.http.post<{ businessId: string }>(
      `/business/me/claims/${claimId}/verify`,
      token ? { token } : {},
    );

  acceptTeamInvite = (token: string) =>
    this.http.post<{ businessId: string }>('/business/me/team-invitations/accept', { token });
}

export const accountService = new AccountService(http);
